// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"c7726673","453":"333c67dd","455":"5e56e0ec","977":"15ab1507"}[chunkId] + ".chunk.js";
};